"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.env = void 0;
const isClientSide = () => typeof window !== 'undefined';
const defaultOptions = {
    warnOnMissing: true
};
/**
 * Retrieves global client-side environment variables set by preloaded __env.js
 * script or server-side process.env environment variables by `key`
 */
const env = (key = '', options = defaultOptions) => {
    var _a, _b;
    // @ts-ignore
    if (isClientSide() && !window.__env) {
        throw new Error('next-isomorphic-runtime-env-browser: window.__env not found; ensure __env.js is properly preloaded in the application');
    }
    // server-side return process.env variable
    if (!isClientSide()) {
        const value = (_a = process.env[key]) !== null && _a !== void 0 ? _a : null;
        return value;
    }
    // @ts-ignore
    const value = (_b = window.__env[key]) !== null && _b !== void 0 ? _b : null;
    if (options.warnOnMissing && value === null) {
        console.warn(`next-isomorphic-runtime-env-browser: key ${key} is missing from the env vars`);
    }
    return value;
};
exports.env = env;
//# sourceMappingURL=index.js.map